import { Box, Grid, TextField } from "@mui/material";
import { INSTRUCTION_DETAILS } from "../UserVisibleStrings";
import React, { SetStateAction, useState } from "react";
import { useRenameTripMutation } from "../../services/routing";
import { renameTripAction } from "../../features/Drawer/drawerSlice";
import { Trip } from "../../generated/gpb/api/route";
import { useDispatch } from "react-redux";
import { faFloppyDisk, faPencil } from "@fortawesome/sharp-duotone-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledRenameButton } from "./Metricstyles";
import ClickAwayListener from "@mui/material/ClickAwayListener";

export interface RenameTripDialogProps
{
    defaultName: string | undefined;
    tripData: Trip | undefined;
}
export default function RenameTripField( props: RenameTripDialogProps ): JSX.Element
{
    const [ tripName, setTripName ] = useState( props.defaultName );
    const [ tripNameEditable, setTripNameEditable ] = useState( false );
    const [ showEditButton, setShowEditButton ] = useState( false );
    const [ renameTrip ] = useRenameTripMutation();
    const dispatch = useDispatch();
    async function handleRename( )
    {
        setTripNameEditable( false );
        if ( tripName !== undefined )
        {
            if ( props.tripData?.Id?.hexString !== undefined )
            {
                dispatch( renameTripAction( tripName ) ); // Optimistic rename
                await renameTrip( { id: props.tripData.Id.hexString, tripName: tripName } );
            }
            else
            {
                alert( "Failed to rename trip to " + tripName );
            }
        }
        else
        {
            // Reset value if save wasn't clicked
            setTripName( props.defaultName );
        }
    }
    function changeName( e: { target: { value: SetStateAction<string> } } )
    {
        const newName = e.target.value;
        if ( newName === undefined ) return;
        setTripName( newName.toString() );
    }
    function handleClickAway()
    {
        setTripNameEditable( false );
        setTripName( props.defaultName );
    }
    let button = undefined;
    if ( tripNameEditable )
    {
        button =
            <StyledRenameButton onClick = {handleRename}>
                <FontAwesomeIcon icon = {faFloppyDisk} size = "sm"/>
            </StyledRenameButton>;
    }
    else if ( showEditButton )
    {
        button =
            <StyledRenameButton onClick = {() => setTripNameEditable( true )}>
                <FontAwesomeIcon icon = {faPencil} size = "sm"/>
            </StyledRenameButton>;
    }
    else
    {
        button = undefined;
    }
    return (
        <ClickAwayListener onClickAway = {handleClickAway}>

            <Grid container>
                <Grid item xs = {11}>
                    <TextField id = "standard-basic"
                        fullWidth
                        value = {tripName ?? INSTRUCTION_DETAILS}
                        variant = "standard"
                        onChange = {changeName}
                        onClick = {() => setTripNameEditable( true )}
                        onMouseEnter = {() => setShowEditButton( true )}
                        onMouseLeave = {() => setShowEditButton( false )}
                        InputProps = {{ disableUnderline: true }}
                        sx = {{
                            "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                            },
                            "& .MuiInputBase-input": {
                                overflow: "hidden",
                                "&:hover": {
                                    color: "#000000",
                                    cursor: "text",
                                    boxShadow: "0 0 3px #1976d2",
                                    borderRadius: "4px"
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid item xs = {1}>
                    <Box sx = {{ flexDirection: "column" }}>
                        {button}
                    </Box>
                </Grid>
            </Grid>
        </ClickAwayListener>
    );
}
